module.exports = __webpack_public_path__ + "static/img/level-card-banner1.0559f25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/6/level-card-banner1.png
// module id = pwFa
// module chunks = 1